"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ViewPageInner = exports.DVLPage = void 0;
const ChartVariant_1 = __importDefault(require("@opsbase/lib-chart/ChartVariant"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const DataTreeController_1 = __importDefault(require("@opsbase/web-ctrl-datatree/DataTreeController"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const ChartBox_1 = __importDefault(require("@opsbase/web-data-chart/ChartBox"));
const web_dvl_cardstack_1 = __importDefault(require("@opsbase/web-dvl-cardstack"));
const web_dvl_table_1 = __importDefault(require("@opsbase/web-dvl-table"));
const DVLToolbar_1 = __importDefault(require("@opsbase/web-dvl-toolbar/DVLToolbar"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const useNav_1 = __importDefault(require("@opsbase/web-nav/useNav/useNav"));
const Fab_1 = __importDefault(require("@opsbase/web-ui/Fab"));
const react_1 = __importStar(require("react"));
const DVLPagePager_1 = __importDefault(require("../DVLPagePager"));
const DVLPageViewMode_1 = __importDefault(require("../DVLPageViewMode"));
const MAX_FIELDS_BEFORE_CHARTS_DISABLED = 25;
const makeMyClasses = () => ({
    root: {
        padding: '8px 16px',
        overflow: 'hidden',
        flex: '1 1 100%',
    },
});
const DVLPage = function (props) {
    const view = (0, useView_1.default)(props.viewId);
    if (!view)
        return null;
    return react_1.default.createElement(exports.ViewPageInner, Object.assign({ key: view.type }, props));
};
exports.DVLPage = DVLPage;
exports.default = exports.DVLPage;
const ViewPageInner = function (props) {
    const { viewId, viewMode = DVLPageViewMode_1.default.TABLE, itemPage, itemCreatePage, itemDeletePage, itemCard, itemSelectionToolbar, itemMenu, itemMenuExpanded = false, disableHeadings = false, disableCounts = false, disableGrouping = false, disableCharts = false, disableFieldSelection = false, disableSaving = false, disableOpsMenu = false, startExpanded, notFoundText, children, padding, fieldSelector, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const view = (0, useView_1.default)(viewId);
    const { goTo } = (0, useNav_1.default)();
    const above = (0, react_1.useMemo)(() => (view === null || view === void 0 ? void 0 : view.chartBox.charts.some(c => !c.hidden && c.chartVariant !== ChartVariant_1.default.COUNT_GROUP)) || false, [view]);
    const handleClickCreate = (0, react_1.useCallback)(() => {
        goTo(itemCreatePage);
    }, [itemCreatePage, goTo]);
    const toolbar = (0, react_1.useMemo)(() => {
        var _a;
        return (react_1.default.createElement(DVLToolbar_1.default, { disableOpsMenu: disableOpsMenu, disableSaving: disableSaving, disableCharts: disableCharts || ((_a = view === null || view === void 0 ? void 0 : view.fields) === null || _a === void 0 ? void 0 : _a.length) > MAX_FIELDS_BEFORE_CHARTS_DISABLED, disableGrouping: disableGrouping, disableFieldSelection: disableFieldSelection, selectionToolbar: itemSelectionToolbar, fieldSelector: fieldSelector }));
    }, [
        disableCharts,
        disableFieldSelection,
        disableGrouping,
        disableOpsMenu,
        disableSaving,
        fieldSelector,
        itemSelectionToolbar,
        view,
    ]);
    const pager = (0, react_1.useMemo)(() => {
        return react_1.default.createElement(DVLPagePager_1.default, null);
    }, []);
    const chart = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (disableCharts ||
            (!(view === null || view === void 0 ? void 0 : view.chartBox.charts.some(c => c.chartVariant === ChartVariant_1.default.SCORE_Q_OP)) &&
                ((_a = view === null || view === void 0 ? void 0 : view.fields) === null || _a === void 0 ? void 0 : _a.length) > MAX_FIELDS_BEFORE_CHARTS_DISABLED))
            return null;
        if (!((_b = view === null || view === void 0 ? void 0 : view.chartBox) === null || _b === void 0 ? void 0 : _b.visible))
            return null;
        return react_1.default.createElement(ChartBox_1.default, { vertical: !above });
    }, [disableCharts, view, above]);
    const dataviewlist = (0, react_1.useMemo)(() => {
        if (children)
            return children;
        const dvlProps = {
            itemPage,
            itemDeletePage,
            itemMenu,
            itemMenuExpanded,
            disableHeadings,
            disableCounts,
            selectable: !!itemSelectionToolbar,
            notFoundText,
        };
        if (viewMode === DVLPageViewMode_1.default.TABLE)
            return react_1.default.createElement(web_dvl_table_1.default, Object.assign({}, dvlProps));
        if (viewMode === DVLPageViewMode_1.default.CARDSTACK)
            return react_1.default.createElement(web_dvl_cardstack_1.default, Object.assign({ itemComponent: itemCard }, dvlProps));
    }, [
        children,
        itemPage,
        itemDeletePage,
        itemMenu,
        itemMenuExpanded,
        disableHeadings,
        disableCounts,
        itemSelectionToolbar,
        notFoundText,
        viewMode,
        itemCard,
    ]);
    const fab = (0, react_1.useMemo)(() => (!itemCreatePage ? null : react_1.default.createElement(Fab_1.default, { onClick: handleClickCreate })), [handleClickCreate, itemCreatePage]);
    return (0, react_1.useMemo)(() => {
        if (!chart || above)
            return (react_1.default.createElement(DataTreeController_1.default, { startExpanded: startExpanded, viewId: viewId },
                react_1.default.createElement(Pane_1.default, { classes: { root: myCss.root }, padding: padding },
                    react_1.default.createElement(Vertical_1.default, { style: { overflow: 'hidden' }, gutter: true },
                        react_1.default.createElement(Pane_1.default, { visible: true }, toolbar),
                        react_1.default.createElement(Pane_1.default, { visible: true }, pager),
                        chart && react_1.default.createElement(Pane_1.default, { visible: true }, chart),
                        react_1.default.createElement(Pane_1.default, { grow: true }, dataviewlist)),
                    fab)));
        return (react_1.default.createElement(DataTreeController_1.default, { startExpanded: startExpanded, viewId: viewId },
            react_1.default.createElement(Pane_1.default, { classes: { root: myCss.root }, padding: padding },
                react_1.default.createElement(Vertical_1.default, { style: { overflow: 'hidden' }, gutter: true },
                    react_1.default.createElement(Pane_1.default, { visible: true }, toolbar),
                    react_1.default.createElement(Pane_1.default, { visible: true }, pager),
                    react_1.default.createElement(Horizontal_1.default, { stretch: true, style: { maxHeight: '100%', overflow: 'hidden' } },
                        react_1.default.createElement(Pane_1.default, { grow: true }, dataviewlist),
                        react_1.default.createElement(Pane_1.default, null, chart))),
                fab)));
    }, [above, startExpanded, viewId, myCss, padding, toolbar, chart, dataviewlist, pager, fab]);
};
exports.ViewPageInner = ViewPageInner;
